import requireAll from 'javascripts/utils/requireAll';

import 'cropperjs/dist/cropper.min.css';
import 'hint.css/hint.base.css';
import 'intl-tel-input/build/css/intlTelInput.min.css';
import 'normalize.css';
import 'primer-tooltips/index.scss';
import 'react-table/react-table.css';
import 'simplelightbox/dist/simplelightbox.scss';
import 'stylesheets/tailwinds.scss';
import 'swiper/dist/css/swiper.css';

requireAll(
  require.context(
    '../stylesheets/',
    true,
    /.*\.scss/,
  ),
);
